import React from 'react';
import LinkButton from 'components/ui/buttons/LinkButton';
import InlineAnnouncement from 'components/ui/InlineAnnouncement';
import demographicSurveyImage from 'assets/illustrations/demographic-survey.png';
import styled from 'styled-components';
import { useAnnouncement } from 'utilities/hooks';
import { URLS } from 'consts';

const DemographicImage = styled.div`
  @media (min-width: ${({ theme }) => theme.screenSizes.tablet}) {
    width: 185px;
    height: 180px;
    flex-shrink: 0;
    background-image: url(${demographicSurveyImage});
    background-size: cover;
  }
`;

const DemographicSurveyPrompt = props => {
  const { announcement, dismiss } = useAnnouncement('demographic-survey');

  return (
    <InlineAnnouncement
      title="Help us learn about our community"
      show={!!announcement}
      onClose={dismiss}
      className="mt-4"
      {...props}
    >
      <div className="d-block d-md-flex flex-nowrap flex-row">
        <div className="pr-0 pr-md-5">
          <p>
            We&apos;re creating a report to help Employers think deeper about
            inclusivity. Would you like to&nbsp;help?
          </p>
          <div className="pt-3">
            <LinkButton
              href={URLS.talentDemographic}
              id="take-survey-link"
              secondary
            >
              Take survey
            </LinkButton>
            <p className="mt-4 mb-0 font-xs">
              Demographic data will be used for reporting and to better
              understand the makeup of The Mom Project&lsquo;s talent community,
              helping us and our partners foster a more fair and inclusive
              workplace.&nbsp;
              <LinkButton
                href={URLS.talentDemographicSurveyLearnMore}
                id="learn-more-link"
                className="nowrap font-weight-bolder"
                target="_blank"
                caret="right"
                link
                inline
              >
                Learn more
              </LinkButton>
            </p>
          </div>
        </div>
        <DemographicImage className="d-none d-md-block rounded-circle"></DemographicImage>
      </div>
    </InlineAnnouncement>
  );
};

export default DemographicSurveyPrompt;
